module.exports = __webpack_public_path__ + "assets1783936157458/img/shouye-select.42bac70b.svg";